export function useCancelableDebounceFn<T>(fn: () => T, delay: number) {
  let timeout: NodeJS.Timeout | null = null
  const caller = function () {
    if (timeout)
      clearTimeout(timeout)
    timeout = setTimeout(() => fn(), delay)
  }

  caller.cancel = () => {
    if (timeout)
      clearTimeout(timeout)
  }

  caller.force = () => {
    if (timeout)
      clearTimeout(timeout)
    fn()
  }

  return caller
}
